// One stable key per asset, for the caches the section views keep beside a
// list: the sanitised-preview map, the scope class its stylesheet is rewritten
// against, and the per-card body view.
//
// The obvious key is the asset id, but a payload is not obliged to carry one —
// and, where a vendor's list has been merged or duplicated, not obliged to keep
// it unique. Either would make two cards share one cache entry, so anything
// missing or already taken falls back to the asset's position in the list.
export function previewKeyMap(assets) {
  const keys = new Map();
  const used = Object.create(null);

  (assets || []).forEach((asset, index) => {
    const id = asset && asset.id !== undefined && asset.id !== null ? String(asset.id) : '';
    // The key becomes part of a CSS class name, so it holds only characters a
    // selector can carry.
    let key = id.trim().replace(/[^\w-]+/g, '-');

    // `used` and the caches this keys are all null-prototype, but Vue's own
    // duplicate-key check and its keyed-patch map are plain objects, so
    // `__proto__` would be reported as a duplicate there however careful this
    // module is. It is treated as a missing id instead.
    if (!key || key === '__proto__' || used[key]) {
      key = `n${index}`;
    }

    while (used[key]) {
      key = `${key}-${index}`;
    }

    used[key] = true;
    keys.set(asset, key);
  });

  return keys;
}

export default previewKeyMap;
